import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useShopping = (page = 1, term = null, type = null, status = null) => useQuery({ queryKey: ['shopping', page, term, type, status], queryFn: async () => {
    const callback = await API.get(`/shopping?page=${page}${term ? `&term=${term}` : ''}${type ? `&type=${type}` : ''}${status ? `&status=${status}` : ''}`)
    return callback?.data
}, staleTime: 1000 * 60})

export default useShopping